
import React, { useState, useEffect } from "react";
import {View, Image, Text, TextInput, FlatList, TouchableOpacity, ActivityIndicator,} from "react-native";
import searchicon from "../../assets/images/search_icon.png";
import {getServiceReq} from "../../api/serviceRequest";
import CImage from "../../common/CImage";
import { COLORS } from "../../constant";
import CText from "../../common/CText";
import useStyles from "./ServiceRequestList_Styles";

export default function ServiceRequestList(props) {
  const styles = useStyles();
  const [data, setData] = useState({ getServiceRequests: [] });
  const [selectedItem, setSelectedItem] = useState("Select Document");
  const [searchText, setSearchText] = useState("");
  const [dataArr, setDataArr] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    vehicleData();
  }, [props.navigation]);

  const vehicleData = () => {
    setLoading(true);
    getServiceReq()
      .then((response) => {
        setLoading(false);
        if (response?.data) {
          setData({ getServiceRequests: response.data });
          setDataArr(response.data);
        } else {
          setData({ getServiceRequests: [] });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("vehicleData err", err);
      });
  };

  const onClickRequestId = (requestId) => {
    console.log(
      data?.getServiceRequests.filter((item) => item.serReqId == requestId)
    );
    props.setSrDataModal(true);
    props.setRequestIdData(
      data?.getServiceRequests.filter((item) => item.serReqId == requestId)
    );
  };

  const filterData = () => {
    let tempArr = dataArr?.filter((item) => {
      return item.serReqId.includes(searchText);
    });
    setData({ getServiceRequests: tempArr });
  };

  useEffect(() => {
    if (searchText && searchText.length > 2) {
      filterData();
    } else if ((searchText && searchText.length < 2) || searchText == "") {
      vehicleData();
    }
  }, [searchText]);

  return (
    <View style={styles.SvcRq_Body}>
      <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
        <View style={styles.listContainer}>
          <View style={styles.listHeader}>
            <Text style={styles.SvcRq_row3_row1_col1_Heading}>
              {"Track Service \n Requests"}
            </Text>
            <View>
              <TouchableOpacity
                style={styles.refreshWrapper}
                onPress={async () => {
                  vehicleData()
                }
                }
              >
                <CImage.RefreshImage />
                <Text style={styles.refresText}>{`Refresh`}</Text>
              </TouchableOpacity>
            </View>
          </View>
          <View style={styles.SvcRq_row3_row1_col2}>
            <View style={styles.searchBar}>
              <TextInput
                style={styles.SvcRq_row3_row1_col2_searchField}
                onChangeText={(e) => setSearchText(e.toUpperCase())}
                value={searchText}
                placeholder="Request ID"
                autoCapitalize={"characters"}
              />
              <View style={styles.SvcRq_row3_row1_col2_searchIcon}>
                <Image
                  source={searchicon}
                  style={styles.SvcRq_row3_row1_col2_searchIcon_image}
                />
              </View>
            </View>
          </View>
          <FlatList
            style={{}}
            showsVerticalScrollIndicator
            data={data?.getServiceRequests}
            renderItem={({ item, index }) => {
              return (
                <View style={styles.listWrapper}>
                  <View style={styles.listLeftCnt}>
                    <CText.srDate>{item?.reqDate}</CText.srDate>
                    <Text style={styles.srStatusStyle}>
                      {item?.requestType}
                    </Text>
                    <CText.srReqId>{item?.serReqId}</CText.srReqId>
                  </View>
                  <View style={styles.listRightCnt}>
                    <Text
                      style={[
                        styles.dataTextStyle1,
                        {
                          fontFamily: "Inter",
                          fontSize: 12,
                          textAlign: "center",
                          paddingVertical: 5,
                          paddingHorizontal: 10,
                          borderRadius: 8,
                          backgroundColor:
                            item?.status === "Approved"
                              ? COLORS.green100
                              : item?.status === "Rejected"
                              ? COLORS.red600
                              : COLORS.orange250,
                        },
                        item?.status === "Approved"
                          ? { color: "green" }
                          : item?.status === "Rejected"
                          ? { color: "red" }
                          : { color: "orange" },
                      ]}
                    >
                      {item?.status}
                    </Text>
                    <TouchableOpacity
                      style={{
                        width: 24,
                        height: 24,
                        backgroundColor: COLORS.grayOP69,
                        borderRadius: 8,
                        marginTop: 15,
                        alignItems: "center",
                        alignSelf: "flex-end",
                      }}
                      onPress={() => onClickRequestId(item?.serReqId)}
                    >
                      <CImage.SrArrowIcon></CImage.SrArrowIcon>
                    </TouchableOpacity>
                  </View>
                </View>
              );
            }}
          />
        </View>
      </View>
      {loading && (
        <View
          style={{
            position: "absolute",
            zIndex: 99,
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
            alignSelf: "center",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 50,
          }}
        >
          <ActivityIndicator size="large" color="#9c1d26" />
        </View>
      )}
    </View>
  );
}

